module.exports = __webpack_public_path__ + "static/media/1988_winter_paralympics2.1fbf978f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1988_winter_paralympics2.jpg
// module id = 962
// module chunks = 0